import client from 'api/client';
// import { AxiosRequestConfig } from 'axios';

export function checkAuthenticationCode(email: string, authentication_code: string) {
    return client.get('/authentication-code', { params: { email, authentication_code } });
}

export function sendAuthenticationCode(email: string) {
    return client.get('/send-authentication-code', { params: { email } });
}
